import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@common-fe/common-fe';

import { Modal } from '@/components';
import { DocumentDetailsCard } from '@/modules/UseMyMoney/components';

interface Props {
  onSetVisible: (value: boolean) => void;
}

const GuidelinesPopup: React.FC<Props> = ({ onSetVisible }) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible
      onSetVisible={onSetVisible}
      testId="guidelines"
    >
      <Text
        data-testid="guidelines-modal_title"
        size="2xl"
        weight={700}
        textAlign="center"
      >
        {t('Guidelines')}
      </Text>
      
      <Box
        data-testid="guidelines-modal_file-type-info"
        margin={{ top: 'spacing24' }}
        pad={{ horizontal: 'spacing16', vertical: 'spacing12' }}
        round="container1Round"
        background="infoContainer"
      >
        <Text data-testid="guidelines-modal_file-type-info_title" weight={700}>
          {t('We support PDF, JPEG, or HEIF. Do you have another file type?')}
        </Text>
        <Text data-testid="guidelines-modal_file-type-info_description" margin={{ top: 'spacing2' }}>
          {t('Please convert the image into an approved file type or ask your provider for an updated receipt as a PDF.')}
        </Text>
      </Box>

      <DocumentDetailsCard margin={{ top: 'spacing12' }} />
    </Modal>
  );
};

export default GuidelinesPopup;
